import { useEffect, useState, useCallback, useRef } from "react";
import TypingBubble from "./TypingBubble";
import { getTokenOrRefresh, SIM_CONFIGS } from "../utils";

const speechsdk = require("microsoft-cognitiveservices-speech-sdk");

const ChatOutput = ({
  stage,
  simulation,
  azureToken,
  message: bot_message,
  onComplete,
  speakingStyle,
  setShowHalo,
  setAzureToken,
  setError, // <-- Receive setError as a prop
  setupWaveformFromSpeaker, // <-- Receive waveform setup function
}) => {
  const [audioConfig, setAudioConfig] = useState();
  const [speechConfig, setSpeechConfig] = useState();
  const [isTyping, setIsTyping] = useState(
    bot_message === undefined || bot_message === ""
  );
  // const [isTyping, setIsTyping] = useState(true)
  const [botTalking, setBotTalking] = useState(true);
  const playerRef = useRef(null);

  console.log("speakingStyle",speakingStyle, bot_message)
  const generateSSML = useCallback((simulation, textToSpeak,stage,speakingStyle) => {
    console.log("generating SSML for simulation -> ", simulation);
    
    const useDynamicStyle = simulation.useBotEmotions;
    const getVoiceConfig = (simulation, stage) => {
      let config;
      
      // Priority 1: Use voiceConfig from API if available
      if (simulation.voiceConfig) {
        config = simulation.voiceConfig;
        console.log("Using voice config from API", config);
      } 
      // Priority 2: Fall back to SIM_CONFIGS based on simType
      else if (simulation.simType && SIM_CONFIGS[simulation.simType?.toUpperCase()]) {
        config = SIM_CONFIGS[simulation.simType.toUpperCase()];
        console.log("Using SIM_CONFIGS fallback", config);
      } 
      // Priority 3: Use DEFAULT config
      else {
        config = SIM_CONFIGS.DEFAULT;
        console.log("Using DEFAULT config", config);
      }
      
      console.log("config", config, "stage", stage);
      
      // Ensure style object exists and has the required stage
      const styleValue = useDynamicStyle 
        ? speakingStyle?.toLowerCase() 
        : (config.style && config.style[stage.toString()] ? config.style[stage.toString()] : config.style?.["1"] || "default");
      
      const styleDegree = config.styleDegree || "1.2";
      const role = config.role ? ` role="${config.role}"` : '';
      
      let ssml = `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="en-US">
        <voice name="${config.voice}">
          <mstts:express-as style="${styleValue}" styledegree="${styleDegree}"${role}>
                <prosody volume="soft">
                  ${textToSpeak}
                </prosody>
              </mstts:express-as>
            </voice>
          </speak>`;

      return ssml;
    };

    return getVoiceConfig(simulation, stage);
  }, [stage])

  // Build speech config from provided azureToken (avoid extra refresh on mount)
  useEffect(() => {
    if (!azureToken || !azureToken.authToken || !azureToken.region) return;
    try {
      const cfg = speechsdk.SpeechConfig.fromAuthorizationToken(
        azureToken.authToken,
        azureToken.region
      );
      setSpeechConfig(cfg);
    } catch (e) {
      console.error("Failed to create SpeechConfig from azureToken", e);
      setError(true);
    }
  }, [azureToken, setError]);

  useEffect(() => {
    console.log("isTyping... --> ", isTyping, bot_message);
    if (!azureToken || !azureToken.authToken || !azureToken.region) return;
    const myPlayer = new speechsdk.SpeakerAudioDestination();

    myPlayer.onAudioEnd = function (_) {
      console.log("on audio end..");
      setBotTalking(false);
      setShowHalo(false);
      onComplete(bot_message);
    };
    myPlayer.onAudioStart = function (_) {
      console.log("on audio start.. setting up waveform");
      console.log("setupWaveformFromSpeaker function:", setupWaveformFromSpeaker);
      // Initialize analyser pipeline when audio actually starts
      if (setupWaveformFromSpeaker) {
        console.log("Calling setupWaveformFromSpeaker with player:", myPlayer);
        setupWaveformFromSpeaker(myPlayer);
      } else {
        console.warn("setupWaveformFromSpeaker function not provided");
      }
    };

    playerRef.current = myPlayer;
    const cfg = speechsdk.SpeechConfig.fromAuthorizationToken(
      azureToken.authToken,
      azureToken.region
    );
    try {
      const ac = speechsdk.AudioConfig.fromSpeakerOutput(myPlayer);
      setAudioConfig(ac);
      setSpeechConfig(cfg);
    } catch (e) {
      console.error("Failed to create AudioConfig/SpeechConfig", e);
      setError(true);
    }
  }, []);

  const talk = useCallback(async (stage) => {
    setBotTalking(true);
    setShowHalo(true);
    if (!speechConfig || !audioConfig) {
      console.log("speech and audio config", speechConfig, audioConfig);
      return;
    }

    let synthesizer = new speechsdk.SpeechSynthesizer(
      speechConfig,
      audioConfig
    );
    console.log("istyping...", isTyping, bot_message);
    if (isTyping || synthesizer === undefined) {
      return;
    }

    const textToSpeak = bot_message;
    const ssml = generateSSML(simulation, textToSpeak,stage,speakingStyle);
    console.log("ssml", ssml);
    console.log(`speaking text: ${textToSpeak}... with player: ${playerRef.current}`);


    console.time && console.time("tts_start_to_audio");
    synthesizer.speakSsmlAsync(
      ssml,
      (result) => {
        let text;
        if (
          result.reason === speechsdk.ResultReason.SynthesizingAudioCompleted
        ) {
          text = `synthesis finished for "${textToSpeak}".\n`;
        } else if (result.reason === speechsdk.ResultReason.Canceled) {
          handleTokenRefresh();
        }
        synthesizer.close();
        synthesizer = undefined;
        console.log(text);
        console.timeEnd && console.timeEnd("tts_start_to_audio");
      },
      function (err) {
        console.log(`Error: ${err}.\n`);
        setError(true);
        handleTokenRefresh();
        synthesizer.close();
        synthesizer = undefined;
      }
    );
    setIsTyping(true);
  }, [isTyping, speechConfig, audioConfig,stage]);

  useEffect(() => {
    console.log("stage",stage)
    if (!isTyping && speechConfig && audioConfig) {
      console.log("calling talk function");
      talk(stage);
    }
  }, [isTyping, speechConfig, audioConfig,stage]);
  const handleTokenRefresh = async () => {
    try {
      const newTokenObj = await getTokenOrRefresh();
      if (newTokenObj.error) {
        throw new Error("Failed to refresh token");
      }
      setAzureToken(newTokenObj);
      const newSpeechConfig = speechsdk.SpeechConfig.fromAuthorizationToken(
        newTokenObj.authToken,
        newTokenObj.region
      );
      setSpeechConfig(newSpeechConfig);
      console.log("Token refreshed successfully.");
      setError(false);
    } catch (error) {
      console.error("Error refreshing token:", error);
      setError(true);
    }
  };
  return (
    <div>
      {botTalking && (
        <div className="flex space-x-4 justify-center">
          {false && <TypingBubble />}
        </div>
      )}
    </div>
  );
};

export default ChatOutput;
